import { NetworkInboundShippingOption } from "@deliverr/inbound-client";

import { getIsFreight } from "../shippingMethodUtils";
import { SHIPPING_OPTION_TO_METHOD } from "inbounds/constants/shippingOptionToMethod";

export const getIsFreightShippingOption = (shippingOption?: NetworkInboundShippingOption): boolean =>
  shippingOption ? getIsFreight(SHIPPING_OPTION_TO_METHOD[shippingOption]) : false;
